"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisconnectEwelinkMutation = exports.useCompleteEwelinkConnectMutation = exports.useStartEwelinkConnectMutation = exports.useGetEwelinkDevicesQuery = exports.useGetEwelinkIntegrationQuery = void 0;
var client_scoped_query_1 = require("../../utils/client-scoped-query");
var device_1 = require("./device");
// Added to deviceApi rather than a new API slice, so the store and sign-out reset need no changes.
var ewelinkApi = device_1.deviceApi.enhanceEndpoints({ addTagTypes: ["ewelink"] }).injectEndpoints({
    endpoints: function (builder) { return ({
        getEwelinkIntegration: builder.query({
            // userId is part of the argument so another account signing in on this browser never reuses the cache.
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/integration/ewelink"),
            keepUnusedDataFor: 0,
            providesTags: ["ewelink"],
        }),
        getEwelinkDevices: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/integration/ewelink/devices"),
            keepUnusedDataFor: 0,
            providesTags: ["ewelink"],
        }),
        startEwelinkConnect: builder.mutation({
            query: function (_a) {
                var clientId = _a.clientId;
                return ({ url: "/v1/integration/ewelink/connect", method: "POST", body: { client_id: clientId } });
            },
        }),
        completeEwelinkConnect: builder.mutation({
            query: function (_a) {
                var clientId = _a.clientId, body = __rest(_a, ["clientId"]);
                return ({ url: "/v1/integration/ewelink/callback", method: "POST", body: __assign(__assign({}, body), { client_id: clientId }) });
            },
            invalidatesTags: ["ewelink"],
        }),
        disconnectEwelink: builder.mutation({
            query: function (_a) {
                var clientId = _a.clientId;
                return ({ url: "/v1/integration/ewelink/disconnect", method: "POST", body: { client_id: clientId } });
            },
            invalidatesTags: ["ewelink"],
        }),
    }); },
});
exports.useGetEwelinkIntegrationQuery = ewelinkApi.useGetEwelinkIntegrationQuery, exports.useGetEwelinkDevicesQuery = ewelinkApi.useGetEwelinkDevicesQuery, exports.useStartEwelinkConnectMutation = ewelinkApi.useStartEwelinkConnectMutation, exports.useCompleteEwelinkConnectMutation = ewelinkApi.useCompleteEwelinkConnectMutation, exports.useDisconnectEwelinkMutation = ewelinkApi.useDisconnectEwelinkMutation;
